import { gql, TypedDocumentNode } from "@apollo/client";

import { WorkerUsage, WorkerUsageBurst, WorkerUsageCycle } from "types/generated";

type GetWorkerUsageBurstData = {
  workerUsage: {
    cycle: Pick<WorkerUsageCycle, "start" | "end">;
    burst: Pick<WorkerUsageBurst, "budgetMinutes" | "usedMinutes"> | null;
    multiAccountContract: WorkerUsage["multiAccountContract"];
  };
};

export const GET_WORKER_USAGE_BURST: TypedDocumentNode<GetWorkerUsageBurstData> = gql`
  query GetWorkerUsageBurst {
    workerUsage {
      cycle {
        start
        end
      }
      burst {
        budgetMinutes
        usedMinutes
      }
      multiAccountContract
    }
  }
`;
